/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignRequestPrimaryAction = {
    OpenSetup: 'open_setup',
    ViewDetails: 'view_details',
    None: 'none'
} as const;
export type EsignRequestPrimaryAction = typeof EsignRequestPrimaryAction[keyof typeof EsignRequestPrimaryAction];


export function EsignRequestPrimaryActionFromJSON(json: any): EsignRequestPrimaryAction {
    return EsignRequestPrimaryActionFromJSONTyped(json, false);
}

export function EsignRequestPrimaryActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignRequestPrimaryAction {
    return json as EsignRequestPrimaryAction;
}

export function EsignRequestPrimaryActionToJSON(value?: EsignRequestPrimaryAction | null): any {
    return value as any;
}

